<div class="reset-page screen-bottom-halo">
  <div class="logo-container">
    <img class="logo-icon" src="assets/images/explain-logo-900.svg" alt="explain_logo" />
    <img class="logo-text" src="assets/images/explain-text-900.svg" alt="explain_text" />
  </div>

  <div class="reset-card">
    <div class="card-header">
      <h2 class="card-title">{{ 'reset-password.title' | translate }}</h2>
      <p class="card-subtitle">{{ 'reset-password.sub-title' | translate }}</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="auth-form">
      <div class="form-field">
        <label for="email" class="field-label">{{ 'reset-password.email' | translate | uppercase }}</label>
        <input
          type="text"
          formControlName="email"
          class="field-input"
          id="email"
          [ngClass]="{ 'field-input--error': isError }"
          autocomplete="email"
          data-cy="forgot-password-email-input"
        />
        @if (isError) {
          <div class="error-banner">
            <i class="ph ph-warning-circle error-icon"></i>
            <span class="error-text">{{ errorMessage | translate }}</span>
          </div>
        }
        <p *ngIf="isEmailSend && !f['email'].errors" class="success-message">
          {{ 'reset-password.email-send-down' | translate }}
        </p>
      </div>

      <div class="form-actions">
        <button type="submit" [disabled]="loading" class="btn-submit btn-forgot-cta" data-cy="forgot-password-submit">
          {{ 'reset-password.reset' | translate }}
        </button>
        <a [routerLink]="['/login']" class="link-secondary" data-cy="forgot-password-back-link">
          {{ 'reset-password.back-to-login' | translate }}
        </a>
      </div>
    </form>
  </div>
</div>
